export default __webpack_public_path__ + "static/media/rich mccormic.83557a9c.jpg";